import { useTranslation } from "react-i18next";
import { useRatePlanQueryObserver } from "../../../../../../api/services";
import { IFormValues } from "../../../../types";
import { FormAutocomplete } from "../../../../../../components/fields";
import {useFormContext, useWatch} from "react-hook-form";

const FormDiscountOverprice = () => {

    const { t } = useTranslation('booking');

    const formContext = useFormContext<IFormValues>();
    const tenant = useWatch({ control: formContext.control, name: "basicDetails.tenant" });
    const dealer = useWatch({ control: formContext.control, name: "basicDetails.dealer" });

    const ratePlanQuery = useRatePlanQueryObserver({tenant: tenant as string, dealer: dealer as string});

    return (
        <FormAutocomplete<IFormValues>
            name="extraServices.discountOverprice"
            label={t('label.discountOverprice')}
            options={ratePlanQuery.data?.discountOverprice ?? []}
            getOptionLabel={(option) => `${option} %`}
            blurOnSelect
        />
    );
};

export default FormDiscountOverprice;
